module.exports = __webpack_public_path__ + "img/cat-mobile-2.bd85bc80.png";